export { default } from './IntegrationAthenaDetailsPopup';
